// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientFinderPatientResponsePhone {
    'phoneNumber'?: string;
    'primaryIndicator'?: string;
    'source'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientFinderPatientResponsePhone>> = [
        {
            "name":     "phoneNumber",
            "baseName": "phoneNumber",
            "type":     "string"
        },
        {
            "name":     "primaryIndicator",
            "baseName": "primaryIndicator",
            "type":     "string"
        },
        {
            "name":     "source",
            "baseName": "source",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PatientFinderPatientResponsePhone.attributeTypeMap;
    }
}
